// extracted by mini-css-extract-plugin
export var fullHeightState = "_1z-7";
export var headerCell = "_1z-1";
export var loadingStateCell = "_1z-4";
export var rowWrapper = "_1z-3";
export var standaloneTable = "_1z-8";
export var standaloneTableWithBodyFill = "_1z-9";
export var stateCell = "_1z-5";
export var table = "_1z-0";
export var tableBodyFiller = "_1z-6";
export var white = "_1z-2";